import {
  CardFragment,
  ElementInput,
  ElementPictureInput,
  PanelInput,
  UpdateCardInput,
} from 'src/graphql'
import {
  EditorElement,
  EditorFullBleed,
  EditorImage,
  EditorPanel,
} from './EditorCard'
import paragraphInputs from './text/paragraphInputs'

const ElementImageUpdate = ({
  image,
  position,
  scale,
  filter,
}: EditorImage): ElementPictureInput =>
  !image
    ? { image: null }
    : {
        image: image.id,
        position,
        scale,
        filter: filter ? filter.name : null,
      }

export const createCleanBackPanel = (backFullBleedPanel: EditorFullBleed) => {
  const panel = backFullBleedPanel.panels[0]
  return {
    backgroundColorObject: panel.backgroundColor,
    location: 0,
    isFullBleed: false,
    elements: panel.elements.map(ElementUpdate),
  }
}

const ElementUpdate = (element: EditorElement): ElementInput => ({
  ...element,
  image: element.image ? ElementImageUpdate(element.image) : null,
  text: element.text ? { paragraphs: paragraphInputs(element.text) } : null,
})

const fullBleedBackgroundPanels = (
  fullBleed: EditorFullBleed,
  fullBleedLocation: number,
) =>
  fullBleed.backgroundElement
    ? [
        {
          location: fullBleedLocation,
          isFullBleed: true,
          backgroundColor: null,
          elements: fullBleed.backgroundElement
            ? [ElementUpdate(fullBleed.backgroundElement)]
            : [],
        },
      ]
    : []

export const panelInput = (panel: EditorPanel): PanelInput => ({
  ...panel,
  location: 0,
  isFullBleed: false,
  elements: panel.elements.map(ElementUpdate),
})

const panels = (fullBleeds: EditorFullBleed[]): PanelInput[] =>
  fullBleeds
    .flatMap((fullBleed, fullBleedLocation) => [
      ...fullBleedBackgroundPanels(fullBleed, fullBleedLocation),
      ...fullBleed.panels.map(panel => ({
        location: undefined,
        isFullBleed: false,
        backgroundColor: panel.backgroundColor,
        elements: panel.elements.map(ElementUpdate),
      })),
    ])
    .reduce(
      (
        { location, panels }: { location: number; panels: PanelInput[] },
        panel,
      ) => ({
        location: panel.location === undefined ? location + 1 : location,
        panels: [
          ...panels,
          {
            ...panel,
            backgroundColor: undefined,
            backgroundColorObject: panel.backgroundColor,
            location: panel.location === undefined ? location : panel.location,
          },
        ],
      }),
      { location: 0, panels: Array<PanelInput>() },
    ).panels

export const cardUpdate = (
  card: CardFragment,
  fullBleeds: EditorFullBleed[],
  recipient: string | null = null,
): UpdateCardInput => ({
  id: card.id,
  panels: panels(fullBleeds),
  recipient,
})
